import { atom } from "jotai";

export const CONSOLIDATED_STORAGE_KEY = "cashflow_consolidated";

function readStoredConsolidated(): boolean {
  if (typeof window === "undefined") return false;
  return window.localStorage.getItem(CONSOLIDATED_STORAGE_KEY) === "true";
}

const baseConsolidatedAtom = atom<boolean>(readStoredConsolidated());

export const consolidatedAtom = atom(
  (get) => get(baseConsolidatedAtom),
  (_get, set, next: boolean) => {
    set(baseConsolidatedAtom, next);
    if (typeof window !== "undefined") {
      window.localStorage.setItem(CONSOLIDATED_STORAGE_KEY, String(next));
    }
  },
);
